import {
  HomeIcon,
  LocationIcon,
  UserIcon,
  TaskIcon,
  TrainIcon,
  ReceiptIcon,
  ClipboardIcon,
  ReportIcon,
  AnchorIcon,
  PackageIcon,
  TruckIcon
} from '@/components/ui/Icons';
import Dashboard from '@/components/dashboard/Dashboard';
import LiveTrackingPage from '@/components/liveTracking/LiveTrackingPage';
import UserManagement from '@/components/userManagement/UserManagement';
import ReportsAnalyticsPage from '../components/reportsAnalytics/ReportsAnalyticsPage';
import RakeMovementReportPage from '@/components/reportsAnalytics/RakeMovementReportPage';
import SecondaryTripReportPage from '@/components/reportsAnalytics/SecondaryTripReportPage';
import TripManagementPage from '@/components/tripManagement/TripManagementPage';
import OtpManagementPage from '@/components/otpManagement/OtpManagementPage';
import AlertsNotificationsPage from '@/components/alertsNotifications/AlertsNotificationsPage';
import ProfilePage from '@/components/profile/ProfilePage';
import PortsManagementPage from '@/components/ports/PortsManagementPage';
import ProductsManagementPage from '@/components/products/ProductsManagementPage';
import VehiclesManagementPage from '@/components/vehicles/VehiclesManagementPage';
import RakePointsManagementPage from '@/components/rakeManagement/rakePoints/table/RakePointsManagementPage';
import RakeReceiptsPage from '@/components/rakeManagement/rakeReceipts/RakeReceiptsPage';
import EditRequestQueuePage from '@/components/tripManagement/editrequests/EditRequestQueuePage';
import RakeMovementsPage from '@/components/rakeManagement/rakeMovements/table/RakeMovementsPage';
import MissingWagonReceiptsPage from '@/components/rakeManagement/missingWagons/MissingWagonReceiptsPage';

export const pageRoutes = {
  dashboard: {
    component: Dashboard,
    title: 'Dashboard',
    icon: HomeIcon
  },
  'live-tracking': {
    component: LiveTrackingPage,
    title: 'Live Tracking',
    icon: LocationIcon
  },
  'user-management': {
    component: UserManagement,
    title: 'User Management',
    icon: UserIcon
  },
  'trip-management': {
    component: TripManagementPage,
    title: 'Trip Management',
    icon: TaskIcon
  },
  'rake-points-management': {
    component: RakePointsManagementPage,
    title: 'Rake Points',
    icon: TrainIcon
  },
  'rake-movements': {
    component: RakeMovementsPage,
    title: 'Rake Trips',
    icon: TrainIcon
  },
  'rake-receipts': {
    component: RakeReceiptsPage,
    title: 'Rake Receipts',
    icon: ReceiptIcon
  },
  'missing-wagon-receipts': {
    component: MissingWagonReceiptsPage,
    title: 'Missing Wagon Receipts',
    icon: ReceiptIcon
  },
  'correction-tickets': {
    component: EditRequestQueuePage,
    title: 'Correction Tickets',
    icon: ClipboardIcon
  },
  'reports-analytics': {
    component: ReportsAnalyticsPage,
    title: 'Primary Trip Report',
    icon: ReportIcon
  },
  'reports-secondary-trip': {
    component: SecondaryTripReportPage,
    title: 'Secondary Trip Report',
    icon: TaskIcon
  },
  'reports-rake-movement': {
    component: RakeMovementReportPage,
    title: 'Rake Movement Report',
    icon: TrainIcon
  },
  profile: {
    component: ProfilePage,
    title: 'Profile',
    icon: UserIcon
  },
  'ports-management': {
    component: PortsManagementPage,
    title: 'Ports Management',
    icon: AnchorIcon
  },
  'products-management': {
    component: ProductsManagementPage,
    title: 'Products Management',
    icon: PackageIcon
  },
  'vehicles-management': {
    component: VehiclesManagementPage,
    title: 'Vehicles Management',
    icon: TruckIcon
  }
};

export default pageRoutes;